import React, { Component, useContext } from "react";
import Auth from "@aws-amplify/auth";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { Site } from "api/typedefs/Site";

interface AuthSiteWrapperContext {
  isAuthenticated: boolean;
  setIsAuthenticated: (authed: boolean) => void;
  siteHasAuthentication: boolean;
  signOut: () => void;
}

interface AuthSiteWrapperProps extends RouteComponentProps {
  site: Site;
}

const defaultAuthContext: AuthSiteWrapperContext = {
  isAuthenticated: false,
  setIsAuthenticated: () => {},
  signOut: () => {},
  siteHasAuthentication: false
};

export const AuthContext = React.createContext<AuthSiteWrapperContext>(
  defaultAuthContext
);

class AuthSiteWrapper extends Component<
  AuthSiteWrapperProps,
  AuthSiteWrapperContext
> {
  constructor(props: AuthSiteWrapperProps) {
    super(props);

    this.state = {
      isAuthenticated: false,
      setIsAuthenticated: (authed: boolean) =>
        this.setState({ isAuthenticated: authed }),
      siteHasAuthentication:
        this.props.site.enabledUserAccounts ||
        defaultAuthContext.siteHasAuthentication,
      signOut: this.signOut
    };
  }

  async componentDidMount() {
    try {
      // calling will refresh session if access token is expired
      await Auth.currentSession();
      this.setState({ isAuthenticated: true });
    } catch (err) {
      if (err) {
        console.log("Error", err);
        console.log("Error name:", err.name);
      }
      // No user session, leave user as unauthenticated
      if (err === "No current user") return;

      // Session exists, but the session's refresh token is expired
      // user needs to sign in again to renew their refresh token
      if (err === "NotAuthorizedException") {
        return this.props.history.push("/auth");
      }
      // unexpected error, shouldn't get to this step
      console.error("Unexpected error in AuthSiteWrapper", err);
    }
  }

  signOut = () => {
    Auth.signOut();
    this.setState({ isAuthenticated: false });
  };

  render() {
    return (
      <AuthContext.Provider value={this.state}>
        {this.props.children}
      </AuthContext.Provider>
    );
  }
}

export const AuthProvider = withRouter(AuthSiteWrapper);
export const AuthConsumer = AuthContext.Consumer;
export const useAuthContext = () => useContext(AuthContext);
